import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApplicationsService, Application } from './applications.interfaces';
import { IEnvironment, Value } from '../environment/environment.interface';
import { IConfigurationService } from '../configuration/configuration-service.interface';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService implements IApplicationsService {
  private url: Value;

  constructor(
    private http: HttpClient,
    @Inject('IEnvironmentService') private envService: IEnvironment,
    @Inject('IConfigurationService') public configurationService: IConfigurationService
  ) {
    this.url = this.envService.getVar('services.api') as string;
  }

  getData(): Observable<Application> {
    return this.http.get<Application>(this.url + '/application');
  }
}
